import { AccountType, type User } from '@/common/types'

type NameSource = Pick<User, 'firstName' | 'lastName'> | null | undefined

export function getDefaultAccountName(accountType: AccountType, user: NameSource): string {
    const firstName = user?.firstName?.trim() || 'User'
    const fullName = [user?.firstName?.trim(), user?.lastName?.trim()].filter(Boolean).join(' ').trim()

    switch (accountType) {
        case AccountType.INDIVIDUAL:
            return fullName || firstName
        case AccountType.INDIVIDUAL_TRUST:
            return `${firstName} Trust`
        case AccountType.COMPANY_TRUST:
            return `${firstName} Company Trust`
        case AccountType.COMPANY:
            return `${firstName} Company`
        default:
            return fullName || firstName
    }
}
